import React, { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { CloseButton } from '../../buttons'
import { ModalWindowSizeEnum } from '../types'

export interface ModalWindowHeaderProps {
  children?: ReactNode
  onClose?: () => void
  size: ModalWindowSizeEnum
  hideHeader?: boolean
}

export const ModalWindowHeader = ({
  onClose,
  size,
  children,
  hideHeader = false,
}: ModalWindowHeaderProps) => {
  const onClick = () => {
    onClose?.()
  }

  return !hideHeader ? (
    <div
      className={twMerge(
        'relative flex w-full items-center',
        'border-border200 border-b',
        size === ModalWindowSizeEnum.Small && 'px-6 py-4',
        size === ModalWindowSizeEnum.Medium && 'px-8 py-6',
      )}
    >
      <span className='basis-full text-heading-3'>{children}</span>
      <CloseButton className="shrink-0" onClick={onClick} />
    </div>
  ) : null
}
